(function () {
    'use strict';

    function contractorProject() {
        return {
            restrict: 'E',
            templateUrl: 'workflow/directives/templates/contractorProject.html',
            link: function (scope) {

            }
        };
    }

    contractorProject.$inject = [];

    angular.module('ecap.workflow').directive('contractorProject', contractorProject);
})();
